module.exports = __webpack_public_path__ + "img/beer_id-28.2ed7ff8c.png";